import React from 'react';
import { useField, ErrorMessage } from 'formik';

const OPTIONS = ['Cell', 'Home', 'Work', 'Other'];

const PhoneTypeSelect = ({ label, name, compulsory }) => {
  const [field, meta] = useField(name);
  return (
    <div className="mb-2">
      <label className="form-label mt-3">{label} {compulsory === true ? <span style={{ color: 'red', fontWeight: 'bold' }}> *</span> : null}</label>
      <select className={`form-control shadow-none ${meta.touched && meta.error ? 'is-invalid' : ''}`} {...field}>
        <option value="">Select type</option>
        {OPTIONS.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
      <ErrorMessage component="div" name={name} className="error" />
    </div>
  );
};
export default PhoneTypeSelect;
